import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer className="bg-lq-ink-black text-lq-paper mt-20" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-5">
                <div className="md:col-span-2">
                    <div className="font-display text-2xl font-semibold tracking-tight">
                        Linguistic <span className="text-lq-peach-500">Quest</span>
                    </div>
                    <p className="mt-3 text-lq-ink-300 text-sm leading-relaxed max-w-sm">
                        Puzzle your way to a new tongue. Heritage and world languages for families, ages 4–16+. Owned and operated by <strong className="text-lq-paper">Southern African Traders Ltd</strong>.
                    </p>
                    <a
                        href="mailto:hello@linguisticquest.com"
                        className="mt-5 inline-flex items-center gap-2 text-sm text-lq-peach-300 hover:text-lq-peach-500"
                        data-testid="footer-email-link"
                    >
                        <Mail size={16} /> hello@linguisticquest.com
                    </a>
                </div>
                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-lq-peach-300">Learn</h4>
                    <ul className="mt-4 space-y-2 text-sm">
                        <li><Link to="/languages" className="text-lq-ink-300 hover:text-lq-paper">Languages</Link></li>
                        <li><Link to="/pricing" className="text-lq-ink-300 hover:text-lq-paper">Pricing</Link></li>
                        <li><Link to="/parents" className="text-lq-ink-300 hover:text-lq-paper">For parents &amp; carers</Link></li>
                        <li><Link to="/schools" className="text-lq-ink-300 hover:text-lq-paper">Schools</Link></li>
                        <li><Link to="/about" className="text-lq-ink-300 hover:text-lq-paper">About</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-lq-peach-300">Support</h4>
                    <ul className="mt-4 space-y-2 text-sm">
                        <li><Link to="/support" className="text-lq-peach-300 hover:text-lq-peach-500 font-semibold" data-testid="footer-support-link">Support us &hearts;</Link></li>
                        <li><Link to="/help" className="text-lq-ink-300 hover:text-lq-paper">Help</Link></li>
                        <li><Link to="/faq" className="text-lq-ink-300 hover:text-lq-paper">FAQ</Link></li>
                        <li><Link to="/contact" className="text-lq-ink-300 hover:text-lq-paper">Contact</Link></li>
                        <li><Link to="/legal/terms" className="text-lq-ink-300 hover:text-lq-paper">Terms</Link></li>
                        <li><Link to="/legal/privacy" className="text-lq-ink-300 hover:text-lq-paper">Privacy</Link></li>
                        <li><Link to="/legal/cookies" className="text-lq-ink-300 hover:text-lq-paper">Cookies</Link></li>
                        <li><Link to="/legal/advertising" className="text-lq-ink-300 hover:text-lq-paper">Advertising policy</Link></li>
                        <li><Link to="/legal/affiliate-agreement" className="text-lq-ink-300 hover:text-lq-paper">Affiliate agreement</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-lq-peach-300">Partner</h4>
                    <ul className="mt-4 space-y-2 text-sm">
                        <li><Link to="/advertise" className="text-lq-ink-300 hover:text-lq-paper">Advertise with us</Link></li>
                        <li><Link to="/affiliates/apply" className="text-lq-ink-300 hover:text-lq-paper">Become an affiliate</Link></li>
                        <li><Link to="/schools" className="text-lq-ink-300 hover:text-lq-paper">Schools</Link></li>
                        <li><a href="mailto:partnerships@linguisticquest.com" className="text-lq-ink-300 hover:text-lq-paper">Affiliate enquiries</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-lq-ink-700">
                <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-lq-ink-300 flex flex-col sm:flex-row justify-between gap-2">
                    <span>© {year} Southern African Traders Ltd. All rights reserved.</span>
                    <span>A puzzle a day keeps the monolingual away.</span>
                </div>
            </div>
        </footer>
    );
}
